import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { EvsProductService } from "../../../../../common/services/EvsProduct.service";
import { ConfirmationService } from "primeng/primeng";
import { ImageService } from "../../../../imageService";
import { AuthBusinessService } from "../../../../../common/services/AuthBusiness.service";

declare var $: any;

@Component({
  selector: "app-boxRetalStampsTH",
  templateUrl: "./boxRetalStampsTH.component.html",
  styles: [``],
  styleUrls: ["./boxRetalStampsTH.component.css"],
  providers: [EvsProductService, ImageService, AuthBusinessService],
})
export class BoxRetalStampsTHComponent implements OnInit {
  @Output() loadDataParent = new EventEmitter();

  addContent = "";
  contentMess = "";
  id = "";
  title = "";
  listContent = [];
  public user: any;

  constructor(private toastr: ToastrService) {
    this.user = JSON.parse(localStorage.getItem("User"));
  }

  ngOnInit() {}

  show(data) {
    this.id = data.id;
    this.contentMess = data.contentMess;
    this.title = data.title;
    this.listContent = data.listContent;
    $(`#${this.id}`).modal("show");
  }

  addContentFunc() {
    const content = this.addContent.toUpperCase().split("\n");
    content.map((res) => {
      if (res.trim().length > 0) {
        this.listContent.push(res.trim());
      }
    });
    if (this.listContent.length > 0) {
      this.loadDataParent.emit(this.listContent);
      this.addContent = "";
      $(`#${this.id}`).modal("hide");
    } else {
      this.toastr.warning(this.contentMess, "Thông báo:", {
        timeOut: 4000,
        positionClass: "toast-top-right",
      });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/boxRetalStampsTH/boxRetalStampsTH.component.ts